import React, { ReactNode } from 'react';

import { Button } from 'shared';

import RootModalLayout from '../RootModalLayout';

import classes from '../SharedModal.module.scss';

interface ConfirmModalProps {
  title: string;
  primaryButtonText: string;
  secondaryButtonText: string;
  children: ReactNode;
  onConfirm: () => void;
  onClose: () => void;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  title,
  primaryButtonText,
  secondaryButtonText,
  children,
  onConfirm,
  onClose,
}) => (
  <RootModalLayout onClose={onClose} title={title}>
    <section className={classes.mainContent}>{children}</section>
    <section className={classes.modalFooter}>
      <Button className={classes.closeButton} onClick={onClose}>
        {secondaryButtonText}
      </Button>
      <Button className={classes.confirmButton} onClick={onConfirm}>
        {primaryButtonText}
      </Button>
    </section>
  </RootModalLayout>
);
